import Styles from './styles.module.css';
import Placeholder from '../../home/_placeholder/index';
import { IoDownloadOutline, IoChatbubbleEllipsesOutline, IoArrowDown } from 'react-icons/io5';
import { DOC_DOWNLOAD_URL, CONSULT_URL } from '../_config';

/* 紙の求人票の束（実画面ではないため CSS で表現）→ 学校管理画面 → 学生アプリ の変化を縦に見せる */
const PaperStack = () => (
  <div className={Styles.papers} aria-hidden="true">
    {[0, 1, 2].map((i) => (
      <div key={i} className={Styles.paper} data-i={i}>
        <span className={Styles.paperBar} />
        <span className={Styles.paperLine} />
        <span className={Styles.paperLine} />
        <span className={Styles.paperLine} />
      </div>
    ))}
  </div>
);

const Hero = () => {
  return (
    <section className={Styles.hero}>
      <div className={Styles.inner}>
        <div className={Styles.copy}>
          <span className={Styles.kicker}>美容・理容専門学校の就職ご担当者さまへ</span>
          <h1>
            毎年届く大量の求人票、
            <br />
            まだスキャン・ファイリングして
            <br className={Styles.brpc} />
            管理していませんか？
          </h1>
          <p className={Styles.lead}>
            紙やPDFで届く求人票を、スキャンして保存し、年度や企業ごとに整理する。
            <br className={Styles.brpc} />
            memorii works なら、求人票を最初からデジタルで受け取り、そのまま学生へ届けられます。
          </p>
          <div className={Styles.actions}>
            <a href={DOC_DOWNLOAD_URL} className={Styles.primary}>
              <IoDownloadOutline />資料をダウンロード
            </a>
            {/* TODO: 学校専用の相談窓口が決まったら遷移先を差し替え（_config.ts） */}
            <a href={CONSULT_URL} className={Styles.secondary}>
              <IoChatbubbleEllipsesOutline />求人票管理について相談する
            </a>
          </div>
        </div>

        <div className={Styles.visual}>
          <figure className={Styles.stage}>
            <span className={Styles.stageTag}>紙・PDFで届く求人票</span>
            <PaperStack />
          </figure>

          <IoArrowDown className={Styles.flowArrow} aria-hidden="true" />

          <figure className={Styles.stage}>
            <span className={Styles.stageTag}>学校の管理画面に届く</span>
            {/* TODO: 学校側 求人情報一覧画面（/school/service/recruit）の実スクリーンショットに差し替え */}
            <Placeholder label="学校側 求人情報一覧画面" height={150} />
          </figure>

          <IoArrowDown className={Styles.flowArrow} aria-hidden="true" />

          <figure className={`${Styles.stage} ${Styles.stagePhone}`}>
            <span className={Styles.stageTag}>そのまま学生へ</span>
            {/* TODO: 学生アプリ（または学生Web）の求人一覧画面の実スクリーンショットに差し替え */}
            <Placeholder label="学生アプリ 求人一覧画面" height={170} />
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Hero;
